import(/* webpackMode: "eager" */ "/builds/vivaldis/vivaldis_interim/frontend/src/app/[locale]/not-found.tsx")